module.exports = __webpack_public_path__ + "07_medium_gold.d4bef25e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/07_medium_gold.png
// module id = 2Va9
// module chunks = 0